let nonInventoriedProductArr = []

document.addEventListener('algolia.hooks.initialize', function () {
  // Autocomplete
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteOptions',
    function (options) {
      // Modify default options, then return them
      options.panelContainer = '#js-autocomplete-container'
      options.detachedMediaQuery = 'none'
      options.placeholder = 'Search the site'
      return options
    }
  )
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteFooterTemplate',
    function (_defaultTemplate, templateOptions, resource) {
      const { html, state } = templateOptions
      const { context, query } = state
      // Modify default options, then return them
      return html`
        <div class="aa-SourceFooter search-results__footer">
          <div class="aa-footer search-results__footer__wrapper">
            <a class="aa-SeeAllBtn view-all__btn" href="/search?q=${query}">
              View all <span>${context.nbProducts}</span> results
            </a>
          </div>
        </div>
      `
    }
  )
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      const { html, item, components } = templateOptions
      // Modify default options, then return them
      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem search-results__link"
          aria-label="${item.title}"
        >
          <div class="aa-ItemContent search-results__item">
            <div
              class="aa-ItemPicture aa-ItemPicture--search-results__item-image"
            >
              <img
                src="${item.image}"
                alt="${item.title}"
                class="image"
                loading="lazy"
              />
            </div>
            <div class="aa-ItemContentBody search-results__body">
              <div
                class="aa-ItemContentTitleWrapper search-results__title-wrapper"
              >
                <div class="aa-ItemContentTitle search-results__title">
                  <p>
                    ${components.Highlight({ hit: item, attribute: 'title' })}
                  </p>
                </div>
                <div class="aa-ItemContentType search-results__type">
                  <p>
                    Tea Type:
                    ${components.Highlight({
                      hit: item,
                      attribute: 'product_type',
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </a>
      `
    }
  )

  // InstantSearch
  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchOptions',
    function (options) {
      options.hitsPerPage = 999
      return {
        ...options,
      }
    }
  )

  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchStatsTemplate',
    function (_defaultTemplate, data, html) {
      return html`
        ${data.hasOneResult &&
        html`
          <p class="mv2 light js--update-result-count" role="status">
            Currently displaying 1 item
          </p>
        `}
        ${data.hasManyResults &&
        html`
          <p class="mv2 light js--update-result-count" role="status">
            Currently displaying ${' '}
            <strong>${algoliaShopify.helpers.formatNumber(data.nbHits)}</strong> items
          </p>
        `}
      `
    }
  )

  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    function (_defaultTemplate, hit, html, components) {
      const bzvId = () => {
        if (hit.meta?.bzv?.review_product) {
          const productId = hit.meta?.bzv?.review_product.split('/')
          return productId[productId.length - 1]
        } else {
          return hit.id
        }
      }

      if (hit.meta?.custom?.product_type[0] == 'Blends') {
        nonInventoriedProductArr.push(hit)
        return
      }

      const isNonInventoried = hit.template_suffix == 'non-inventoried'
      const isBundle = hit.tags?.includes('fastbundle')
      const oosProduct = hit.tags?.includes('out-of-stock')
      const isBisProduct = hit.can_order == false

      return html`
        <hh-product-card-variants
          class="ais-hit ais-product custom-product"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
        >
          <a
            class="js-anchor product-card__link"
            href="${algoliaShopify.helpers.instantsearchLink(hit)}"
          >
            <div class="product-card__media">
              <img
                class="ais-hit--picture product-media"
                src="${algoliaShopify.helpers.largeImage(hit)}"
                alt="${hit.title} - ${hit.variant_title}"
                loading="lazy"
              />
            </div>
          </a>
            <div class="product-card__info product-card__entry">
              <a
                class="product-card__title--link"
                href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              >
                <p
                  class="product-card__title text-utility text-utility--medium c-teal"
                >
                  ${hit.title}
                </p>
              </a>
              ${hit.template_suffix == 'non-inventoried'
                ? html`<a
                    href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                    ><p
                      class="product-card__description text-utility text-utility--small c-gold"
                    >
                      ${hit.product_type}
                    </p></a
                  >`
                : ''}
              ${hit.meta?.description?.secondary &&
              hit.template_suffix != 'non-inventoried'
                ? html`<p
                    class="product-card__description text-utility text-utility--small c-gold"
                  >
                    <a href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                      >${hit.meta?.description?.secondary[0]}</a
                    >
                  </p>`
                : ''}
              ${hit.meta?.description?.secondary &&
              hit.template_suffix == 'non-inventoried'
                ? html`<div
                    class="product-card__description gold text-utility text-utility--small text-utility--alt c-gold"
                  >
                    <a href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                      >${hit.meta?.description?.secondary[0]}</a
                    >
                  </div>`
                : ''}
              ${!oosProduct ? html`
                <p class="ais-hit--price">
                  ${hit.meta?.custom?.product_type != 'Blends' &&
                  hit.template_suffix == 'non-inventoried'
                    ? html`<span>From </span>`
                    : ''}
                  ${hit.compare_at_price > hit.price &&
                  html`
                  <span class="ais-hit--price-striked"
                    ><span
                      >${algoliaShopify.helpers.displayStrikedPrice(
                    hit.price,
                    hit.compare_at_price
                  )}</span
                    ></span
                  >
                `}
                  <span>
                  ${algoliaShopify.helpers.displayPrice(
                    hit,
                    hit._distinct
                  )}
                </span>
                </p>
              ` : ''}
              <div
                data-bv-show="inline_rating"
                data-bv-product-id="${bzvId()}"
                data-bv-redirect-url="${algoliaShopify.helpers.instantsearchLink(
                  hit
                )}"
                data-bv-seo="false"
              ></div>

              ${
                __GLOBAL__.showProductCardATC ? html`
                <div class="product-card__atc">
                  ${isNonInventoried &&
                  !isBisProduct &&
                  !oosProduct &&
                  html`<hh-button-wrapper theme="primary" class="view-bundle">
                    <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
                      View Products
                    </a>
                  </hh-button-wrapper>`}
                  ${!isNonInventoried &&
                  !oosProduct &&
                  !isBisProduct &&
                  !isBundle &&
                  hit.price > 0 &&
                  html`<hh-broadcast on="productAdded" event="modal" class="block">
                    <hh-product-form show-mini-cart class="block">
                      <form
                        method="post"
                        action="/cart/add"
                        id="card-product-form-${hit.objectID}"
                        accept-charset="UTF-8"
                        class="form shopify-product-form"
                        enctype="multipart/form-data"
                        novalidate
                        data-type="add-to-cart-form"
                      >
                        <input type="hidden" name="form_type" value="product" />
                        <input type="hidden" name="utf8" value="✓" />
                        <input name="quantity" type="hidden" value="1" />
                        <input type="hidden" name="id" value="${hit.objectID}" />
                        <div class="product-form__actions">
                          <div class="product-form__buttons">
                            <hh-button-wrapper
                              class="atc__btn"
                              width="full"
                              theme="primary"
                            >
                              <button type="submit" name="add">Add to Bag</button>
                            </hh-button-wrapper>
                          </div>
                        </div>
                        <input
                          type="hidden"
                          name="product-id"
                          value="${hit.objectID}"
                        />
                      </form>
                    </hh-product-form>
                  </hh-broadcast>`}
                  ${oosProduct ? html`
                    <hh-button-wrapper theme="tertiary" class="bis-cta__btn">
                      <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
                        Out of stock
                      </a>
                    </hh-button-wrapper>
                  ` : ''}
                  ${isBundle &&
                  !isBisProduct &&
                  html`<hh-button-wrapper theme="primary" class="view-bundle">
                    <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
                      View Bundle
                    </a>
                  </hh-button-wrapper>`}
                  ${!isNonInventoried &&
                  !oosProduct &&
                  isBisProduct &&
                  html`<hh-broadcast
                      event="modal"
                      data='{"id": "bis-modal__product--${hit.id}"}'
                      class="no-js-hidden"
                      disable-body-scroll
                    >
                      <hh-button
                        theme="tertiary"
                        id="bisModalBtn--${hit.id}"
                        class="bis-cta__btn"
                        type="button"
                        aria-haspopup="dialog"
                      >
                        Email When Available
                      </hh-button>
                    </hh-broadcast>
                    <hh-modal
                      id="bis-modal__product--${hit.id}"
                      class="bis-modal bis-modal__product"
                    >
                      <form-bis-notification
                        product-id="${hit.id}"
                        product-title="${hit.title}"
                        variant-id="${hit.objectID}"
                      >
                      </form-bis-notification>
                    </hh-modal>`}
                </div>` : ''
              }
            </div>
        </hh-product-card-variants>
      `
    }
  )

  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchMainTemplate',
    function (_defaultTemplate, data, html) {
      const productTemplate = html`
        <div class="ais-page container">

          <div class="ais-facets-button">Show filters</div>
          <div class="ais-facets ${!__GLOBAL__.showAlgoliaSortBy && !__GLOBAL__.showAlgoliaFilters ? 'hidden' : ''} ">
            <div class="ais-input">
              <div class="ais-search-box-container"></div>
              <div class="ais-input-button">
                <div class="ais-clear-input-icon"></div>
              </div>
            </div>
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            <div class="ais-sort ${__GLOBAL__.showAlgoliaSortBy ? '' : 'hidden'}">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `
                }
            </div>
            <div class="${__GLOBAL__.showAlgoliaFilters ? '' : 'hidden'}">
              ${data.facets.map(
                (facet) =>
                  html`
                    <div
                      class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName} accordion--filter"
                    >
                      <input
                        class="ais-dropdown-checkbox"
                        type="checkbox"
                        id="${facet.escapedName}"
                        name="dropdown"
                      />
                      <label
                        for="${facet.escapedName}"
                        class="ais-range-slider--header ais-facet--header ais-header accordion__title-wrapper"
                      >
                        <h2 class="accordion__title filter__label c-teal uppercase text-utility text-utility--medium">${facet.title}</h2>
                      </label>
                      <div
                        class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                      ></div>
                    </div>
                  `
              )}
            </div>
          </div>

          <div class="ais-block main-search__results product-grid container ${!__GLOBAL__.showAlgoliaSortBy && !__GLOBAL__.showAlgoliaFilters ? 'no-sidebar' : ''} ">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span
                  class="ais-change-display-block ais-change-display-selected"
                >
                  <i class="fa fa-th-large"></i>
                </span>
                <span class="ais-change-display-list">
                  <i class="fa fa-th-list"></i>
                </span>
              </div>
            </div>

            <hh-product-grid>
              <div class="ais-hits-container ais-results-as-block"></div>
            </hh-product-grid>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `
      return productTemplate
    }
  )

  algoliaShopify.hooks.registerHook(
    'afterISStartRemoveDefaultWidget',
    function (defaultWidgets) {
      // Find and return the default pagination widget
      const defaultPaginationWidget = defaultWidgets.find(
        (widget) => widget.$$widgetType === 'ais.pagination'
      )

      return [defaultPaginationWidget]
    }
  )
})

// Custom
document.addEventListener('algolia.autocomplete.afterInit', function () {
  const parent = document.querySelector('.aa-Form')
  const headerActionEl = document.querySelector('.js-header-actions')
  const closeBtn = document.querySelector('.aa-InputWrapperSuffix')
  const submitBtn = document.querySelector('.js-header-search-submit')
  const formSubmit = document.querySelector('.aa-SubmitButton')
  parent.insertBefore(headerActionEl, closeBtn)
  submitBtn.addEventListener('click', function (e) {
    e.preventDefault()
    formSubmit.click()
  })
})

document.addEventListener('algolia.instantSearch.onRender', function () {
  if (nonInventoriedProductArr.length <= 0) return

  let templateSection = ''

  nonInventoriedProductArr.map((hit) => {
    const bzvId = () => {
      if (hit.meta?.bzv?.review_product) {
        const productId = hit.meta?.bzv?.review_product.split('/')
        return productId[productId.length - 1]
      } else {
        return hit.id
      }
    }

    const tags = function () {
      if (
        hit.meta.description?.tags &&
        hit.template_suffix == 'non-inventoried'
      ) {
        let tagsElem = ''
        hit.meta.description?.tags.forEach((tag) => {
          tagsElem += `<span class="product-card__tag">${tag}</span>`
        })
        return tagsElem
      }
    }

    templateSection += `
      <li class="ais-Hits-item">
        <hh-product-card-variants
          class="ais-hit ais-product custom-product"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
        >
          <a
            class="js-anchor product-card__link"
            href="${algoliaShopify.helpers.instantsearchLink(hit)}"
          >
            <div class="product-card__media">
              <img
                class="ais-hit--picture product-media"
                src="${algoliaShopify.helpers.largeImage(hit)}"
                alt="${hit.title} - ${hit.variant_title}"
                loading="lazy"
              />
            </div>
          </a>
          <div class="product-card__info-wrapper">
            <div class="product-card__info product-card__entry">
              ${
                hit.template_suffix == 'non-inventoried'
                  ? `<a
                      href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                      ><p
                        class="product-card__description text-utility text-utility--small c-gold"
                      >
                        ${hit.product_type}
                      </p></a
                    >`
                  : ''
              }
              <a
                class="product-card__title--link"
                href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              >
                <p
                  class="product-card__title text-utility text-utility--medium c-teal"
                >
                  ${hit.title}
                </p>
              </a>
              ${
                hit.meta.description?.secondary &&
                hit.template_suffix != 'non-inventoried'
                  ? `<p
                      class="product-card__description text-utility text-utility--small c-gold"
                    >
                      <a href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                        >${hit.meta.description.secondary[0]}</a
                      >
                    </p>`
                  : ''
              }
              ${
                hit.meta.description?.entry &&
                hit.template_suffix == 'non-inventoried'
                  ? `<div
                      class="product-card__description gold text-utility text-utility--small text-utility--alt c-gold"
                    >
                      <a href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                        >${hit.meta.description?.entry[0]}</a
                      >
                    </div>`
                  : ''
              }
              ${
                hit.meta.description?.tags &&
                hit.template_suffix == 'non-inventoried'
                  ? `<p class="product-card__tags text-utility text-utility--smaller text-utility--medium">
                    ${tags()}
                  </p>
              `
                  : ''
              }
              <div
                data-bv-show="inline_rating"
                data-bv-product-id="${bzvId()}"
                data-bv-redirect-url="${algoliaShopify.helpers.instantsearchLink(
                  hit
                )}"
                data-bv-seo="false"
              ></div>
              ${
                hit.template_suffix == 'non-inventoried' &&
                `<div class="product-card__atc">
                  <hh-button-wrapper theme="primary" class="view-bundle">
                    <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
                      View Products
                    </a>
                  </hh-button-wrapper>
                </div>`
              }
            </div>
          </div>
        </hh-product-card-variants>
      </li>`
  })

  if (typeof $BV !== 'undefined') $BV.ui()

  // const flavorSection =
  //   '<div class="ais-results-as-block"><h2 class="main-search__products-title mv0 mb1 uppercase light center">Blends</h2><div class="ais-Hits"><ol class="ais-Hits-list">' +
  //   templateSection +
  //   '</ol></div></div>'

  // document
  //   .querySelector('.custom-flavor-container')
  //   .insertAdjacentHTML('beforebegin', flavorSection)
})
